// type: 'project' | 'work' | 'education'
// branch: 'feature' (projects) | 'main' (work/education) — drives git graph

const timelineEntries = [
  {
    type: 'project',
    branch: 'feature',
    title: 'Sentinel — Real-Time ML Inference Pipeline',
    org: null,
    date: '2026',
    location: null,
    what: 'Live BULLISH / BEARISH / NEUTRAL signals from real market data — streamed, classified, and served continuously.',
    infra: 'GCP Pub/Sub · Cloud Run · BigQuery · Firestore · Terraform · scikit-learn · FastAPI · serverless-native',
    description: 'Serverless GCP pipeline that streams live market data through Pub/Sub, extracts technical indicators on Cloud Run, and runs a trained ML classifier. Predictions land in BigQuery, session state in Firestore, all provisioned with Terraform.',
    tags: ['Cloud Run', 'Pub/Sub', 'BigQuery', 'Firestore', 'Terraform', 'Python', 'FastAPI', 'scikit-learn'],
    link: 'https://github.com/adsouza5/sentinel-ml-pipeline',
    status: null,
    live: true,
    showcase: 'MLPipelineShowcase',
  },
  {
    type: 'project',
    branch: 'feature',
    title: 'Prism — API Gateway with Auth & Rate Limiting',
    org: null,
    date: '2026',
    location: null,
    what: 'Routes, authenticates, and throttles every API request. Real-time traffic visibility and JWT inspection without touching client-side auth.',
    infra: 'Go · Cloud Run · WebSockets · JWT · sliding-window rate limiting · reverse proxy core · Docker',
    description: 'Production-grade API gateway with JWT authentication, per-client sliding-window rate limiting, and intelligent request routing. Built in Go with a reverse proxy core, a WebSocket-powered live admin dashboard, and a React UI showing real-time traffic, client quota usage, and JWT token inspection. Deployed on Cloud Run.',
    tags: ['Go', 'JWT', 'Rate Limiting', 'Reverse Proxy', 'WebSockets', 'React', 'Cloud Run', 'Docker'],
    link: 'https://github.com/adsouza5/prism-api',
    status: null,
    live: true,
    showcase: 'Prism',
  },
  {
    type: 'project',
    branch: 'feature',
    title: 'Lens — Semantic Code Search Engine',
    org: null,
    date: '2026',
    location: null,
    what: 'Search any GitHub repo in plain English. Sub-second results with file paths, line numbers, and relevance scores — no grep, no guessing.',
    infra: 'Python · FastAPI · Qdrant vector DB · tree-sitter (function-level chunking) · jina / OpenAI / Ollama embeddings · Cloud Run',
    description: 'Index any GitHub repository and query it in plain English. Code is chunked with tree-sitter (function/class level), embedded using your choice of model, and stored in Qdrant for sub-second vector similarity search.',
    tags: ['Python', 'FastAPI', 'Qdrant', 'tree-sitter', 'sentence-transformers', 'OpenAI', 'React', 'Cloud Run'],
    link: 'https://github.com/adsouza5/lens-api',
    status: null,
    live: true,
    showcase: 'Lens',
  },
  {
    type: 'work',
    branch: 'main',
    title: 'Software Developer',
    org: 'Synechron',
    date: "Mar '24 – Present",
    location: 'New York, NY',
    what: '350+ enterprise features shipped. 40% OCR throughput gain. One-week critical client demo — owned and delivered.',
    infra: 'Python · OpenCV · Tesseract · React · Node.js · Kotlin · Java · enterprise-scale',
    description: 'Engineered a production-grade OCR pipeline (Python, OpenCV, Tesseract) increasing digitization throughput by 40%. Delivered a high-priority client demo under a one-week deadline. Owned end-to-end frontend delivery for a large-scale enterprise client — 350+ feature requests. Spearheaded Java → Kotlin modernization cutting build time by 25%.',
    tags: ['Python', 'OpenCV', 'Tesseract', 'React', 'Node.js', 'Kotlin', 'Java'],
    link: null,
    status: null,
  },
  {
    type: 'project',
    branch: 'feature',
    title: 'Flux — Universal Unit Converter',
    org: null,
    date: '2024',
    location: null,
    what: '17 measurement types, live currency rates, voice input — entirely in the browser. Ask in plain English or speak it.',
    infra: 'React · in-browser Whisper (audio never leaves device) · Web Audio API · Frankfurter API · NLP',
    description: 'Universal converter spanning 17 measurement types. Understands natural language queries typed or spoken via in-browser Whisper. Real-time Frankfurter currency rates and a dynamic audio-reactive visualizer.',
    tags: ['React', 'Whisper', 'Web Audio API', 'Frankfurter', 'NLP', 'Voice UI'],
    link: 'https://github.com/adsouza5/currency-convert-chatbot',
    status: null,
    showcase: 'Flux',
  },
  {
    type: 'project',
    branch: 'feature',
    title: 'CodeCollab — Real-Time Collaborative Editor',
    org: null,
    date: '2023',
    location: null,
    what: 'Code together without merge conflicts. Each developer owns their segment — editable only by them, visible to all.',
    infra: 'Y.js CRDT · Monaco Editor · Piston API sandboxed execution · Socket.io · Firebase · SHA-256 passcode auth',
    description: 'Segment-based real-time collaborative editor. Eliminates merge conflicts by design. Shared state synced via Y.js (CRDT). Monaco Editor with per-owner colour decorations. Piston API handles sandboxed multi-language execution.',
    tags: ['React', 'Y.js', 'CRDT', 'Monaco Editor', 'Piston API', 'Socket.io', 'Firebase', 'Node.js'],
    link: 'https://github.com/adsouza5/RealTimeCoding',
    status: null,
    showcase: 'CodeCollab',
  },
  {
    type: 'education',
    branch: 'main',
    title: 'B.Sc. Computer Science',
    org: 'Arizona State University',
    date: "Jan '20 – Dec '23",
    location: 'Tempe, AZ',
    what: "GPA 3.64 · Dean's List · New American University Award. Four years of CS fundamentals that underpin every system I build.",
    infra: 'Algorithms · Distributed Systems · Operating Systems · Mobile Dev · Software QA',
    description: "GPA 3.64 · Dean's List · New American University Award. Coursework: Data Structures & Algorithms, iOS Mobile App Development, Operating Systems, Distributed Software Development, Software QA & Testing.",
    tags: ['Algorithms', 'Operating Systems', 'Mobile Dev', 'Distributed Systems'],
    link: null,
    status: null,
  },
  {
    type: 'work',
    branch: 'main',
    title: 'Frontend Engineering Intern',
    org: 'Etherea',
    date: "Jan '23 – Dec '23",
    location: 'Tempe, AZ',
    what: '40% user engagement increase. 200K simultaneous Firebase connections. Google OAuth shipped on a live wellness product.',
    infra: 'React Native · Firebase · Google Auth · iOS · Android · Agile cadence',
    description: 'Spearheaded iOS and Android feature development in React Native, driving a 40% increase in user engagement. Integrated Google Firestore handling up to 200,000 simultaneous connections and shipped Google OAuth.',
    tags: ['React Native', 'Firebase', 'Google Auth', 'iOS', 'Android', 'Agile'],
    link: null,
    status: 'Internship',
  },
  {
    type: 'education',
    branch: 'main',
    title: 'Oracle Certified Associate — Java SE 8',
    org: 'Oracle',
    date: '2023',
    location: null,
    what: 'Industry certification validating core Java competency — OOP, collections, exception handling.',
    infra: 'Java · OOP · Collections · Exception Handling · Data Types',
    description: 'Industry certification validating core Java programming competency — OOP, data types, operators, exception handling, and the Java Collections framework.',
    tags: ['Java', 'OOP', 'Certification'],
    link: null,
    status: null,
  },
];

export default timelineEntries;
